











import TextFilterVue from "@/components/consents-filters/TextFilter.vue";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      modelArray: [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }],

      dataArray: [
        { responseDescription: "Pisnelo" },
        { responseDescription: "Anotnio" },
        {},
        {}
      ]
    };
  },

  components: {
    "c-text-filter": TextFilterVue
  }
});
